import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PlayersService } from '../../../services/players/players';
import { ListQuest } from '../../../services/lists/list-quest';
import { ListRoles } from '../../../services/lists/list-roles';
import { AllStatus } from '../../../../core/services/status/all-status';
import { Subscription } from 'rxjs';
import { NgScrollbarModule } from 'ngx-scrollbar';

@Component({
  selector: 'app-tmp-wt-players-info',
  imports: [TranslatePipe, NgScrollbarModule],
  templateUrl: './tmp-wt-players-info.html',
  styleUrl: './tmp-wt-players-info.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TmpWtPlayersInfo implements OnInit{

  data =  input<any>();
  user =  input<any>();
  roomInfo = input<any>(); 

  listQuest = inject(ListQuest);
  listRoles = inject(ListRoles);

  allStatus = inject(AllStatus);
  subscriptionCL: Subscription;

  constructor( private ref: ChangeDetectorRef){}

  ngOnInit(): void {
    this.subscriptionCL = new Subscription();
    this.listQuest.quests = [];
    this.listQuest.getAllQuests();
    this.listRoles.roles = [];
    this.listRoles.getAllRoles();
    
    this.subscriptionCL.add(this.listQuest.questsUpdated$.subscribe(() => this.ref.markForCheck()));
    this.subscriptionCL.add(this.listRoles.rolesUpdated$.subscribe(() => this.ref.markForCheck()));
    this.subscriptionCL.add(this.allStatus.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.ref.markForCheck();
      }
    }));
    this.ref.markForCheck();
  }

  ngOnDestroy(): void {
    if(this.subscriptionCL){
      this.subscriptionCL.unsubscribe();
    }
  }

  roleQuest(rq_id: unknown){
    
    return ( (rq_id as number) > 100 )?this.getStringQuest(rq_id):this.getStringRole(rq_id);
  }

  getStringQuest(rq_id: unknown){
    let result = (this.listQuest.quests)?this.listQuest.findQuest(rq_id as number):null;
   
    return (result?.data?.humman_description?.title)?result?.data?.humman_description.title : '';
  }

  getStringRole(rq_id: unknown){
    let result = this.listRoles.findRole(rq_id as number);
    return (result?.data?.humman_description?.title)?result.data.humman_description.title : '';
  }

  statusPalsyers(playerId: number): boolean{
    let isReady: boolean = false;
    if(this.data()){
      if( playerId <= (this.data().length -1)  ){
        isReady = this.data()[playerId].is_ready;
      }
    }
    return isReady;
  }

  isPlayer(playerId:number):string{
    let notPlayer:string = 'empty-player';
    if(this.data()){
      if( playerId <= (this.data().length -1)  ){
        notPlayer = '';
      }
    }
    return notPlayer;
  }

  playerName(player: number): string{
    let name: string = '';
    
      if(this.data()){
        if( player <= (this.data().length -1)  ){
          if(this.data()[player]?.is_ready){
            name = this.data()[player]?.name || ''; 
          }
        }
      }
    return name;
  }

  whatPlayerRQ(player: number):string{
    let rqName:string = this.roleQuest(101);
    if(this.data().length > 0){
      if( player <= (this.data().length -1)  ){
        if(this.data()[player]?.is_ready){
          rqName = this.roleQuest(this.data()[player].rq_id);
        }
      }
    }
    return rqName ?? '';
  }

}
